// vendors
import { StaticImage } from 'gatsby-plugin-image';
import React from 'react';
import Carousel from '../../components/Carousel';

function RestaurantCarousel() {
  return (
    <Carousel>
      <StaticImage
        height={448}
        className="aspect-[6336/9504] fluid-h-[12/28]"
        quality={90}
        sizes="(max-width: 1920px) 16vw,298px"
        src="../../images/restaurant/carousel/April-Bistro-Carrousel-01.jpg"
        alt={``}
      />

      <StaticImage
        height={448}
        className="aspect-[6145/6144] fluid-h-[12/28]"
        quality={90}
        sizes="(max-width: 1920px) 24vw,448px"
        src="../../images/restaurant/carousel/April-Bistro-Carrousel-02.jpg"
        alt={``}
      />

      <StaticImage
        height={448}
        className="aspect-[6336/9504] fluid-h-[12/28]"
        quality={90}
        sizes="(max-width: 1920px) 16vw,298px"
        src="../../images/restaurant/carousel/April-Bistro-Carrousel-03.jpg"
        alt={``}
      />

      <StaticImage
        height={448}
        className="aspect-[6051/9076] fluid-h-[12/28]"
        quality={90}
        sizes="(max-width: 1920px) 16vw,298px"
        src="../../images/restaurant/carousel/April-Bistro-Carrousel-04.jpg"
        alt={``}
      />
    </Carousel>
  );
}

export default RestaurantCarousel;
